module.exports = new __parcel__URL__("c1s3.3a845053.png").toString();